import { render, staticRenderFns } from "./FormQuestionOpenEndedType.vue?vue&type=template&id=4add5a27"
import script from "./FormQuestionOpenEndedType.vue?vue&type=script&lang=js"
export * from "./FormQuestionOpenEndedType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports